{
  "loading": "Chargement...",
  "error": "Erreur",
  "success": "Succès",
  "cancel": "Annuler",
  "save": "Enregistrer",
  "close": "Fermer",
  "yes": "Oui",
  "no": "Non",
  "required": "Requis",
  "optional": "Facultatif",
  "conditional": "Conditionnel",
  "submitted": "Soumis",
  "approved": "Approuvé",
  "pending": "En Attente"
}